angular.module('ihestiaCommonDirectives.baseDownloadHelper', [
  'ihestiaRestServicesBase'
  ]);